import { useEffect, useRef } from 'react';

const AdBlockHorizontalMultiplex = () => {
  const adRef = useRef();

  useEffect(() => {
    try {
      if (window.adsbygoogle && adRef.current) {
        window.adsbygoogle.push({});
      } 
    } catch (e) {
      console.error("Adsense error:", e);
    }
  }, []);

  return (
    <center>
      <ins
        className="adsbygoogle"
        style={{ display: 'block' }}
        data-ad-format="autorelaxed"
        data-ad-client="ca-pub-1759319613562086"
        data-ad-slot="8928844625"
        ref={adRef}
      ></ins>
    </center>
  );
};

export default AdBlockHorizontalMultiplex;
